import { atom } from "jotai"

// Add min height to avoid shifting when USP banner is present
export const uspBannerHeightAtom = atom<number>(30)
